module.exports = __webpack_public_path__ + "img/poches-on.6779e21e.svg";